import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

let pushedByUs = false;

export function useTelegramBotPopup() {
    const route = useRoute();
    const router = useRouter();

    const isShowPopup = computed(() => route.query.telegramBot === '1');

    function openPopup() {
        if (isShowPopup.value) return;
        pushedByUs = true;
        router.push({ query: { ...route.query, telegramBot: '1' } });
    }

    function closePopup() {
        if (!isShowPopup.value) return;
        if (pushedByUs) {
            pushedByUs = false;
            router.back();
            return;
        }
        const query = { ...route.query };
        delete query.telegramBot;
        router.replace({ query });
    }

    return {
        isShowPopup,
        openPopup,
        closePopup,
    };
}
